var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_header",style:(_vm.cssVars)},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"inner"},[(_vm.title)?_c('h1',{domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.parsedCta)?_c('a',{attrs:{"href":_vm.parsedCta.url,"title":_vm.parsedCta.title},domProps:{"innerHTML":_vm._s(_vm.parsedCta.title)}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/PageHeader.vue